import { useEffect, useState } from "react";

const ScrollFadeOverlay = () => {
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const fadeStart = 0;
      const fadeEnd = 150;
      
      if (scrollY <= fadeStart) {
        setOpacity(0);
      } else if (scrollY >= fadeEnd) {
        setOpacity(0.95);
      } else {
        const fadeProgress = (scrollY - fadeStart) / (fadeEnd - fadeStart);
        setOpacity(fadeProgress * 0.95);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div 
      className="fixed top-0 left-0 right-0 h-24 bg-gradient-to-b from-background to-transparent pointer-events-none z-40 transition-opacity duration-200"
      style={{ opacity }}
    />
  );
};

export default ScrollFadeOverlay;
